import React from 'react';
import PropTypes from 'prop-types';

import {
  StyledLabel,
  StyledLabelLight,
  StyledLabelBold,
  StyledLabelItalic,
  StyledLabelInline,
  StyledLabelSmall,
  StyledLabelBase
} from './Styles';

const propTypes = {
  testId: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node
};

const defaultProps = {
  testId: undefined,
  className: undefined,
  children: undefined
};

const Label = ({ className, children, testId, variant }) => (
  <StyledLabel data-testid={testId} className={className} variant={variant}>
    {children}
  </StyledLabel>
);

// TODO Remove Label properties as it has been added to variants
Label.Light = StyledLabelLight;
Label.Bold = StyledLabelBold;
Label.Italic = StyledLabelItalic;
Label.Inline = StyledLabelInline;
Label.Base = StyledLabelBase;
Label.Small = StyledLabelSmall;

Label.propTypes = propTypes;
Label.defaultProps = defaultProps;

export default Label;
